import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=b9fd3580&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./_Footer.scss?vue&type=style&index=0&id=b9fd3580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fd3580",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LanguageSelector: require('/opt/components/LanguageSelector.vue').default})
